import { auth } from "../services/firebase";

export function signInWithGoogle() {
	const provider = new auth.GoogleAuthProvider();
	return auth().signInWithPopup(provider);
}

export function signInWithFacebook() {
	const provider = new auth.FacebookAuthProvider();
	return auth().signInWithPopup(provider);
}

export async function signInAsGuest(userName) {
	await auth().signInAnonymously()

	if (auth().currentUser) {
		await auth().currentUser.updateProfile({
			displayName: userName
		})
	}
}

export function signOut() {
	auth().signOut();
}